import * as z from 'zod';

export type BillingEntityFormSchemaValues = z.infer<typeof billingEntityFormSchema>;
export const billingEntityFormSchema = z.object({
    name: z.string().nonempty(),
    email: z.email().optional().nullable(),
    uic: z.string().nonempty(),
    code: z.string().nonempty(),
    tax_registration_number: z.string().optional().nullable(),
});
